import { render, staticRenderFns } from "./ChangeNameDialog.vue?vue&type=template&id=59c57ff6&scoped=true&"
import script from "./ChangeNameDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeNameDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeNameDialog.vue?vue&type=style&index=0&id=59c57ff6&lang=scss&scoped=true&"
import style1 from "./ChangeNameDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c57ff6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
